import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Input, Output, EventEmitter, Inject } from '@angular/core';
import * as moment from 'moment';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { AppointmentService } from "../_services/appointment.service";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.css']
})
export class OTPVerificationComponent implements OnInit, OnDestroy {

  twilio_from: string;
  account_sid: string;
  auth_token: string;
  twilio_to: any = [];
  messageObj: any;
  displayMsg: string;
  randomOTP: any;
  service_sid: any;
  contact_ids: any = [];
  otp: any;
  phone_no: any;
  full_phone: string;
  invalidOtp: boolean = false;
  dialogData: any = {
    show: false,
    header: '',
    value: ''
  }
  twilioCreds: any;
  verificationStatus: boolean;
  resendDisabled: boolean = false;
  resendCountdown: number = 0;
  private countdownInterval: any;
  whatsappConfig: any = null; // Cache WhatsApp config
  resendingOtp: boolean = false; // Loading state for resend
  otpChannel: string = ''; // Track which channel was used: 'WhatsApp' or 'SMS'
  initialSendComplete: boolean = false; // Track if initial send is complete


  constructor(
    private appointmentService: AppointmentService,
    @Inject(MAT_DIALOG_DATA) public formData, private dialogRef: MatDialogRef<OTPVerificationComponent>
  ) { }

  phoneValidation = new FormControl('', Validators.required);
  otpValidation = new FormControl('', Validators.required);
  countryCodeValidation = new FormControl('', Validators.required);

  @ViewChild('ngOtpInput') ngOtpInputRef: any;



  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '30px',
      'height': '30px'
    }
  };

  async ngOnInit() {
    this.full_phone = this.formData.countryCode + this.formData.phone;

    // Load WhatsApp config once
    this.whatsappConfig = await this.appointmentService.checkWhatsappConfig();

    this.sendOtp();
    console.log(this.formData);
  }

  ngOnDestroy() {
    // Clean up interval on component destroy
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  startResendCountdown() {
    this.resendDisabled = true;
    this.resendCountdown = 30;

    this.countdownInterval = setInterval(() => {
      this.resendCountdown--;
      if (this.resendCountdown <= 0) {
        this.resendDisabled = false;
        clearInterval(this.countdownInterval);
      }
    }, 1000);
  }


  async sendOtp() {
    this.randomOTP = this.appointmentService.generateOtp();
    console.log("OTP=>", this.randomOTP);
    this.full_phone = this.formData.countryCode + this.formData.phone;
    let acc_name = this.appointmentService.acc_name;

    // ── Use cached WhatsApp config ──
    if (this.whatsappConfig && this.whatsappConfig.otpVerification?.enabled) {
      console.log('WhatsApp OTP enabled, trying WhatsApp OTP...');
      // ── Try WhatsApp First (via sendWhatsappOtp cloud function) ──
      this.appointmentService.sendWhatsappOtp(this.full_phone, this.randomOTP.toString()).subscribe(
        (resp: any) => {
          if (resp && resp.success) {
            console.log('OTP sent successfully via WhatsApp');
            this.otpChannel = 'WhatsApp';
            this.resendingOtp = false;
            this.initialSendComplete = true;
            this.startResendCountdown();
          } else {
            console.warn('WhatsApp OTP failed, falling back to SMS:', resp);
            this.sendOtpViaSms(acc_name);
          }
        },
        (err) => {
          console.warn('WhatsApp OTP error, using SMS fallback:', err);
          this.sendOtpViaSms(acc_name);
        }
      );
    } else {
      console.log('WhatsApp OTP not enabled, using SMS directly');
      await this.sendOtpViaSms(acc_name);
    }
  }

  async sendOtpViaSms(acc_name: string) {
    console.log('Using Twilio SMS for OTP');
    try {
      const twilioCreds = await this.appointmentService.getTwilioCredentials();
      this.twilioCreds = twilioCreds;
      console.log('Twilio credentials loaded');

      this.messageObj = {
        from: this.twilioCreds.twilio_from,
        to: [this.full_phone],
        acc_sid: this.twilioCreds.account_sid,
        auth_token: this.twilioCreds.auth_token,
        service_sid: this.twilioCreds.notify_service_sid,
        msg: this.randomOTP + ' is One time password (OTP) for your ' + acc_name + ' appointment. Please do not share this. If not requested, please inform us.',
        contact_ids: [],
      };
      console.log('Sending SMS via Twilio');
      this.appointmentService.sendSms(this.messageObj);
      this.otpChannel = 'SMS';
      this.resendingOtp = false;
      this.initialSendComplete = true;
      this.startResendCountdown();
    } catch (err) {
      console.error('Failed to send OTP via Twilio:', err);
      this.resendingOtp = false;
      this.initialSendComplete = true;
    }
  }

  onOtpChange(otp) {
    this.otp = otp;
    if (this.otp.length == 6) {
      if (this.otp == this.randomOTP) {
        this.verificationStatus = true;
        this.verifyOTP()
      } else {
        this.verificationStatus = false;
      }
    }
  }

  verifyOTP() {
    if (this.otp == this.randomOTP) {
      this.appointmentService.otpVerified = true
      this.dialogRef.close(true);
    }
    else {
      this.otp = "";
      this.dialogData = {
        show: true,
        header: 'Invalid OTP',
        value: 'invalidOtp'
      }
    }
  }

  resendOtp() {
    if (this.resendDisabled) {
      return; // Don't allow resend during countdown
    }

    this.resendingOtp = true; // Show loading
    this.otp = '';
    this.ngOtpInputRef.setValue(this.otp);
    this.sendOtp();
    this.invalidOtp = true;
    this.dialogData = {
      show: true,
      header: 'Resend OTP',
      value: ''
    }
  }


  changeEmail() {
    this.otp = "";
    this.ngOtpInputRef.setValue(this.otp);
  }

}
